// extracted by mini-css-extract-plugin
export var option = "_4t-1";
export var optionActive = "_4t-2";
export var pill = "_4t-0";